import Feed from './Feed';
import './styles/Profile.css'
import { AuthContext } from './context';
import { useContext } from 'react';

const Profile = () => {
    const { user } = useContext(AuthContext);
    return(
        <div className = 'profile'>
            <h3 className = 'profile_text'>Your Posts</h3>
            <Feed profile = {user?.displayName}/>
            {console.log(user)}
        </div>
    );
} 

export default Profile;